export default __webpack_public_path__ + "static/media/CAB.e8453459.svg";